<template>
  <div class="pt-7.5 px-23.5 flex flex-col slide">
    <video
      style="-webkit-mask-image:radial-gradient(circle at center,#000 33%,transparent 70%);"
      autoplay
      loop
      muted
      class="w-145 h-145 mx-auto"
      src="@/assets/videos/projects.mp4" alt=""></video>
    <div class="content relative -top-18 flex flex-col ">
      <div class="header flex justify-between">
        <p class="fz-202" style="color: rgba(50, 55, 73, 1)">/ {{ text.projects }}</p>
        <img class="h-10 w-10" src="@/assets/images/box.svg" alt="">
      </div>
      <p class="mt-12.5 text-justify fz-201 font-medium" style="text-indent: 15rem">{{ text.bigExp }}</p>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "projectsSlide1",
  computed:{
    text(){
      return require("@/assets/text/projects/slide1/" + this.lang + ".json")
    },
    ...mapState(['lang'])
  }
};
</script>

<style scoped>

</style>
